<template>
<div class="champion-wrap">
    <h2 class="champion-label">スーパーモト全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2005-2010</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">2005年<span class="year-title__sub">平成17年</span></h2>
                <ul>
                    <li>佐合 潔／moto1</li>
                    <li>三苫 進／moto2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2006年<span class="year-title__sub">平成18年</span></h2>
                <ul>
                    <li>佐合 潔／moto1アンリミテッド</li>
                    <li>松本 康／moto1</li>
                    <li>佐合 潔／moto2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2007年<span class="year-title__sub">平成19年</span></h2>
                <ul>
                    <li>小林 好美／moto1アンリミテッド</li>
                    <li>大楽 竜也／moto1</li>
                    <li>佐々木 貴志／moto2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2008年<span class="year-title__sub">平成20年</span></h2>
                <ul>
                    <li>小林 好美／moto1アンリミテッド</li>
                    <li>星野 優位／moto1</li>
                    <li>佐々木 貴志／moto2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2009年<span class="year-title__sub">平成21年</span></h2>
                <ul>
                    <li>渋井 健／moto1 OPEN</li>
                    <li>佐合 潔／moto1</li>
                    <li>高山 直人／moto2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2010年<span class="year-title__sub">平成22年</span></h2>
                <ul>
                    <li>松本 康／moto1 PRO</li>
                    <li>坂牧 隆夫／moto1 OPEN</li>
                    <li>山下 政弘／moto2</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('110')"><span class="history__head--circle">2011-2020</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">2011年<span class="year-title__sub">平成23年</span></h2>
                <ul>
                    <li>佐合  潔／moto1 PRO</li>
                    <li>赤嶺 涼太／moto1 OPEN</li>
                    <li>大西健太郎／moto2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2012年<span class="year-title__sub">平成24年</span></h2>
                <ul>
                    <li>佐合  潔／moto1 PRO</li>
                    <li>高山 直人／moto1 OPEN</li>
                    <li>久保  晶／moto2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2013年<span class="year-title__sub">平成25年</span></h2>
                <ul>
                    <li>佐合  潔／S1 PRO</li>
                    <li>吉田 雄一／S1 OPEN</li>
                    <li>輿水 拓弥／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2014年<span class="year-title__sub">平成26年</span></h2>
                <ul>
                    <li>佐合  潔／S1 PRO</li>
                    <li>金子 和之／S1 OPEN</li>
                    <li>城取  諒／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2015年<span class="year-title__sub">平成27年</span></h2>
                <ul>
                    <li>佐合  潔／S1 PRO</li>
                    <li>古川 和由／S1 OPEN</li>
                    <li>中木 亮輔／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2016年<span class="year-title__sub">平成28年</span></h2>
                <ul>
                    <li>森田 一輝／S1 PRO</li>
                    <li>吾妻 裕人／S1 OPEN</li>
                    <li>富田 真司／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2017年<span class="year-title__sub">平成29年</span></h2>
                <ul>
                    <li>森田 一輝／S1 PRO</li>
                    <li>富田 真司／S1 OPEN</li>
                    <li>平  翔太／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2018年<span class="year-title__sub">平成30年</span></h2>
                <ul>
                    <li>森田 一輝／S1 PRO</li>
                    <li>庄司 秀人／S1 OPEN</li>
                    <li>土橋 亮一／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2019年<span class="year-title__sub">平成31年/令和元年</span></h2>
                <ul>
                    <li>日浦大治朗／S1 PRO</li>
                    <li>小原 堅斗／S1 OPEN</li>
                    <li>大森 雅俊／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2020年<span class="year-title__sub">令和2年</span></h2>
                <ul>
                    <li>日浦大治朗／S1 PRO</li>
                    <li>広瀬 彰信／S1 OPEN</li>
                    <li>佐々木貴志／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2021年<span class="year-title__sub">令和3年</span></h2>
                <ul>
                    <li>日浦 大治朗／S1 PRO</li>
                    <li>松本 和資／S1 OPEN</li>
                    <li>小鹿 翼／S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2022年<span class="year-title__sub">令和4年</span></h2>
                <ul>
                    <li>小原 堅斗／S1 PRO</li>
                    <li>田所 隼／S1 OPEN</li>
                    <li>原島 剛／S2</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['100']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>